export class IRoleArtifactItem {
    name:string = "";
    key:string = "";
    status:"Outstanding"|"Complete" = "Outstanding";
}
export class RoleArtifactItem extends IRoleArtifactItem {
    constructor(options?: IRoleArtifactItem) {
        super();
        if (options) {
            this.name = options.name ?? this.name;
            this.key = options.key ?? this.key;
            this.status = options.status ?? this.status;
        }
    }
    toJSON() {
        return {
            name: this.name,
            key: this.key,
            status: this.status,
        }
    }
}

export class IRoleArtifact {
    role: string = "";
    artifacts: RoleArtifactItem[] = [];
    total: number = 0;
    outstanding: number = 0;
    completed: number = 0;
    percent: number = 0; //UI side
}

export class RoleArtifact extends IRoleArtifact {

    constructor(options?: IRoleArtifact) {
        super();
        if (options) {
            this.role = options.role ?? this.role;
            this.total = options.total ?? this.total;
            this.outstanding = options.outstanding ?? this.outstanding;
            this.completed = options.completed ?? this.completed;
            this.percent = Math.ceil(this.completed * 100 / this.total);
            if (options.artifacts) {
                options.artifacts.forEach(value => {
                    this.artifacts?.push(new RoleArtifactItem(value))
                })
            }
        }
    }

    toJSON() {
        return {
            role: this.role,
            total: this.total,
            outstanding: this.outstanding,
            completed: this.completed,
            artifacts: this.artifacts.map(i => i.toJSON()),
        }
    }
}